module.exports = __webpack_public_path__ + "img/time.3239a6e0.png";